import React, { useState, useRef } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faCheck } from "@fortawesome/free-solid-svg-icons";

const CopyToClipboardIcon = ({ textToCopy }) => {
  const [isCopied, setIsCopied] = useState(false);
  const copyTimeoutRef = useRef(null);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setIsCopied(true);

      // Clear previous timeout if any
      if (copyTimeoutRef.current) {
        clearTimeout(copyTimeoutRef.current);
      }

      // Reset the icon back to copy after 3 seconds
      copyTimeoutRef.current = setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  React.useEffect(() => {
    return () => {
      if (copyTimeoutRef.current) {
        clearTimeout(copyTimeoutRef.current);
      }
    };
  }, []);

  return (
    <button
      onClick={handleCopy}
      title={isCopied ? "Copied!" : "Copy to clipboard"}
      style={{ cursor: 'pointer', border: 'none', background: 'none', padding: 0 }}
    >
      {isCopied ? <FontAwesomeIcon icon={faCheck} />  : <FontAwesomeIcon icon={faCopy} />}
    </button>
  );
};

export default CopyToClipboardIcon;
